export default __webpack_public_path__ + "static/media/eye2.32a62407.svg";